<template>
  <q-row>
    <q-col :span="5">
      <q-collapse accordion>
        <q-collapse-item
          v-for="group in groups"
          :key="group.key"
          :name="group.caption"
        >
          <template slot="title">
            <span>{{ group.caption }}</span>
          </template>
          <q-drag
            element="ul"
            :list="group.components"
            :options="componentsOptions"
            :clone="onClone"
          >
            <li
              v-for="component in group.components"
              :key="component.key"
              class="q-draggable__item"
              style="border: 1px solid #8e8e8e"
            >
              <span>{{ component.label }}</span>
            </li>
          </q-drag>
        </q-collapse-item>
      </q-collapse>
    </q-col>
    <q-col :span="14">
      <div v-if="elements.length > 0">
        <q-button
          type="danger"
          :disabled="disabled"
          @click.stop="clearItems()"
        >
          {{ this.$qt('el.draggable.emptyText') }}
        </q-button>
      </div>
      <q-drag
        element="ul"
        :list="elements"
        :class="['list-group dropArea', !elements.length ? 'empty' : '']"
        :options="formOptions"
        :move="onMove"
        :data-content="this.$qt('el.draggable.dataContent')"
        @start="isDragging = true"
        @end="isDragging = false"
      >
        <li
          v-for="(element, index) in elements"
          :key="index"
          class="list-group-item q-draggable__item"
          :style="index % 2 === 0 ? 'background-color: #EBEBEB' : 'background-color: #D7D7D7'"
        >
          <q-element-generator
            v-model="model"
            :element="element"
          />
          <q-button-group>
            <q-button
              :disabled="disabled"
              type="text"
              @click="removeElement(index)"
            >
              <font-awesome-icon :icon="['fas', 'trash']" />
            </q-button>
            <q-button
              :disabled="disabled"
              type="text"
              @click="elementDetail(index)"
            >
              <font-awesome-icon :icon="['fas', 'cog']" />
            </q-button>
          </q-button-group>
        </li>
      </q-drag>
    </q-col>
    <q-col :span="5">
      <q-json>{{ elements }}</q-json>
    </q-col>


    <q-dialog
      title="جزئیات"
      width="50%"
      append-to-body
      :visible.sync="elementSettingDialog"
    >
      <q-element-setting
        v-model="currentElement"
        :model="{}"
      />

      <span slot="footer">
        <q-button
          type="primary"
          @click="elementSettingDialog = false"
        >تایید</q-button>
      </span>
    </q-dialog>
  </q-row>
</template>

<script>

  import availableElements from "./availableElements";
  import elementSetting from "./elementSetting";

  export default {
    name: "QFormDesigner",

    components:{
      'q-element-setting': elementSetting
    },

    mixins: [availableElements],

    props: {
      value: {type: Array, required: true},
      disabled: {type: Boolean, default: false}
    },
    
    data() {
      return {
        model: {},
        elements: [],
        elementSettingDialog: false,
        currentElement: undefined,

        isDragging: false,
        delayedDragging: false
      }
    },
    computed: {
      componentsOptions() {
        return {
          disabled: this.disabled,
          sort: false,
          group: {
            name: 'components',
            pull: 'clone',
            put: false
          }
        }
      },
      formOptions() {
        return {
          handle: '.list-group-item',
          group: {
            name: 'components'
          }
        }
      }
    },

    watch: {
      value() {
        this.elements = this.value;
      },
      elements() {
        this.$emit('input', this.elements);
      },

      isDragging(newValue) {
        if (newValue) {
          this.delayedDragging = true
          return
        }
        this.$nextTick(() => {
          this.delayedDragging = false
        })
      }
    },
    created() {
      this.elements = this.value;
    },

    methods: {
      onMove({relatedContext, draggedContext}) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      },
      onClone(el) {
        let input = JSON.parse(JSON.stringify(el));
        input.runtimeId = this.$tools.getRandomRuntimeId();
        input.fixed = false;
        input.property = input.type + this.$tools.getRandomRuntimeId();

        return input
      },
      elementDetail(index) {
        this.currentElement = this.elements[index];
        this.elementSettingDialog = true;
      },
      removeElement(index) {
        this.elements.splice(index, 1)
      },
      clearItems() {
        this.elements = [];
      },
    },

  }
</script>

<style scoped>

  .q-draggable__item {
    list-style: none;
    line-height: 36px;
    padding: 0 20px;
    margin: 0;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    outline: 0
  }


  .vue-green {
    background: #41b883 !important;
  }

  .mdi {
    font-size: 1.4em;
  }

  .mdi-pin, .mdi-pin-off, .mdi-close {
    cursor: pointer;
  }

  .mdi:before {
    vertical-align: bottom;
  }

  .collection-item {
    cursor: move;
  }

  .dropArea {
    position: relative;
    min-height: 440px;
    padding: 10px 0;
  }

  .dropArea.empty {
    opacity: 0.5;
    border: 1px dashed black;
    border-width: 3px;
    box-shadow: none;
  }

  .dropArea.empty:after {
    content: attr(data-content);
    position: absolute;
    text-align: center;
    top: 50%;
    left: 0;
    width: 100%;
  }

  .collapsible-header {
    width: 100%;
  }

  .collapsible-body {
    padding: 1rem 2rem !important;
    width: 100%;
    background: #fff;
  }

  .middle {
    height: 56px;
    line-height: 56px;
    text-align: center
  }

  .no-margin-bot {
    margin-bottom: 0 !important;

  }

  .sortable-ghost {
    opacity: 0;
  }
</style>